<template>
  <main>
    <section class="online">
      <section class="preview">
        <ul class="sidebar">
          <li v-for="frame in frames" :key="frame.number"
            :class="{ 'active': mainVideo.name === frame.number }"
            @click="selectVideoMain(frame.number)" class="thumbnail-item">
            <img
              :src="`https://livechat-ero.com/freechat/img/thumb${frame.number}.${frame.format}`"
              alt="">
          </li>
        </ul>
        <div class="preview-container flex">
          <div v-if="mainVideo.is_pr" class="pr">
            <a href="https://bn.dxlive.com/Click153/9172025-103-195545"
              target="_blank"></a>
            <div class="video-container">
              <div class="video-container-inner">
                <a href="https://bn.dxlive.com/Click153/9172025-103-195545"
                  target="_blank"></a>
                <div class="video-loading" v-if="isVideoLoading">読み込み中...</div>
                <video width="1000" height="800"
                  :src="`https://livechat-ero.com/freechat/mov/dx_sample${mainVideo.name}.mp4`"
                  controls loop muted autoplay
                  @loadstart="isVideoLoading = true"
                  @canplay="isVideoLoading = false"></video>
              </div>
            </div>
          </div>
          <div v-else class="iframe-container">
            <iframe
              :src="`https://rtcstatic.dxlive.com/freechatpreview/${mainVideo.name}`"
              frameborder="0">
            </iframe>

            <a href="https://bn.dxlive.com/Click153/9172025-103-195545"
              target="_blank" class="play-link">
            </a>
          </div>
          <article class="preview__block">
            <a class="join-bt"
              href="https://bn.dxlive.com/Click153/9172024-103-195545"
              target="_blank">
              期間限定<br>DXLIVEとスペシャルコラボ！<br>
              <span class="yellow">無料18ポイント登録は</span>
              <span class="underline">コチラから</span>
            </a>
            <section class="online__block">
              <h2>モロ見せライブ配信中！</h2>
              <div v-if="freeChatPerformers.length == 0" class="notice flex">
                <p>現在、有料エリアで激しいオナニー中です！</p><a class="prof-bt orange"
                  href="https://bn.dxlive.com/Click153/9172024-103-195545"
                  target="_blank">サイトでオナニーを覗く</a>
              </div>
              <div v-else class="thumbnails flex">
                <dl v-for="(val, i) in freeChatPerformers" :key="i"
                  :class="['thumbnail', { 'active': selectedName === val.performer_name }]">
                  <dt class="info--top">
                    <div class="thumail--img" @click="selectVideoMain(val)">
                      <img :src="val.thumbnail_url" :alt="val.performer_name">
                    </div>
                  </dt>
                  <dd class="name">{{ val.performer_name }}</dd>
                </dl>
              </div>
            </section>
            <dl class="review">
              <dt>ユーザーレビュー</dt>
              <dd>
                {{ mainVideo.memo }}
              </dd>
            </dl>
          </article>
        </div>
      </section>
    </section>
  </main>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import axios from 'axios';

export default {
  setup() {
    const mainVideo = ref({})
    const isVideoLoading = ref(true)
    const defaultReview = ref([
      "こんな可愛い子がなぜに、ここまで激しいプレイを？最初はスローにスタートするけどヒートアップしてくるとかならずバイブを使って、局部挿入シーンを見せてくれます。自分の場合はツーショットに移ったけど、その時には潮吹きプレイありましたよ！オススメです！",
      "最近かなり可愛い子が増えてきてるけど、この子もその一人。自分のお気に入りです。ビデオ映像の質が高く、M字開脚が感動もの！ラブンス接続して動かしてあげると、チップのお返しがありました。性格も良いので長く遊べる女の子でしたね。",
      "激しいプレイを好むなら、バッチリです。バイブ2つ穴挿入で昇天してました。常時お客が10人くらいついてるので人気あるんでしょうね。音声がたまに乱れることもあったけど、喘ぎ声も大きめで興奮します！",
      "きれいなお姉さんタイプで、憧れの存在です。手足も長くスタイルも良いですね。プレイはそこまで激しく無いけど、きれいな体を拝めるだけでも幸せ。リモちゃプレイが好きみたいなので、リクエストに答えてあげて下さい。調子が良ければ潮吹きしてくれます。",
      "DXライブでもトップクラスの女の子。ルックスよし。スタイルよし。こちらのリクエストは何でも答えてくれます。途中でツーショットに誘われたけど、自分の方が時間切れで今回は断念しました。次回は二人だけでゆっくり楽しみたいです。"
    ])
    const primePerformers = ref([])
    const freeChatPerformers = ref([])
    const reloadInterval = ref(null)
    const loading = ref(false)

    const prMov = ref(null)
    const selectedName = ref(null)
    const frames = computed(() => {
      if (!prMov.value) return []
      const allFrames = prMov.value.map(section => {
        const frames = [];
        for (let i = 0; i < section.count; i++) {
          frames.push({
            number: section.baseIndex + i + 1,
            format: section.format
          });
        }
        return frames;
      }).flat();

      // Fisher-Yates shuffle algorithm
      for (let i = allFrames.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [allFrames[i], allFrames[j]] = [allFrames[j], allFrames[i]];
      }

      return allFrames;
    })

    const loadData = async () => {
      console.log('loadData')
      loading.value = true;
      try {
        const response = await axios.get('https://bn.dxlive.com/json/prime_performers', {
          responseType: 'text'
        });
        const jsContent = response.data;
        const script = document.createElement('script');
        script.textContent = jsContent;
        document.body.appendChild(script);
        primePerformers.value = window.prime_performers;
        document.body.removeChild(script);
        freeChatPerformers.value = primePerformers.value
          .filter(performer => performer.session === 'freeChat' || performer.session === 'standBy')
          .sort((a, b) => a.performer_name.localeCompare(b.performer_name, 'ja'));

        if (frames.value.length > 0 && !mainVideo.value.name) {
          // 初回ロード時のみ最初のビデオを再生
          selectVideoMain(frames.value[0].number);
        }
        loading.value = false;
      } catch (error) {
        console.error('Error fetching prime performers:', error);
        loading.value = false;
      }
    }
    const loadConfig = async () => {
      try {
        const response = await fetch('./config.json')
        const text = await response.text()
        try {
          const data = JSON.parse(text)
          prMov.value = data.videoSections
          // configロード後、framesが生成されたら最初のビデオを設定
          if (frames.value.length > 0) {
            selectVideoMain(frames.value[0].number);
          }
        } catch (parseError) {
          console.error('JSON parse error:', parseError)
        }
      } catch (error) {
        console.error('Fetch error:', error)
      }
    }
    const startAutoReload = () => {
      // 既存のインターバルをクリア
      if (reloadInterval.value) {
        clearInterval(reloadInterval.value);
      }

      // PRビデオ表示時のみ60秒ごとに次のビデオを再生
      reloadInterval.value = setInterval(() => {
        // mainVideo.is_prがtrueの場合のみ次のビデオを再生
        if (frames.value.length > 0 && mainVideo.value.is_pr) {
          console.log('Playing next video...');
          // 現在のビデオのインデックスを取得
          const currentIndex = frames.value.findIndex(frame => frame.number === mainVideo.value.name);
          // 次のインデックスを計算（最後なら最初に戻る）
          const nextIndex = (currentIndex + 1) % frames.value.length;
          // 次のビデオを再生
          selectVideoMain(frames.value[nextIndex].number);
        }
      }, 60000);

      // ページが非表示になった時にインターバルをクリア
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          clearInterval(reloadInterval.value);
        } else {
          startAutoReload();
        }
      });
    }

    const selectVideoMain = (data) => {
      console.log('selectVideoMain', data)
      isVideoLoading.value = true;  // ビデオ切り替え時にローディング表示

      // 前回の状態を保存
      const wasPlayingPR = mainVideo.value.is_pr;

      if (data && data.performer_name) {
        selectedName.value = data.performer_name
        mainVideo.value = {
          name: data.performer_name,
          memo: data.prime_memo,
          is_pr: false
        }
        console.log('selectVideoMain:str', mainVideo.value)

        // iframeに切り替わった場合は自動再生を停止して再開
        if (wasPlayingPR) {
          clearInterval(reloadInterval.value);
          startAutoReload();
        }
      } else {
        selectedName.value = data
        mainVideo.value = {
          name: data,
          memo: defaultReview.value[Math.floor(Math.random() * defaultReview.value.length)],
          is_pr: true
        }
        console.log('selectVideoMain:num', mainVideo.value)

        // PRビデオに切り替わった場合は自動再生を開始
        if (!wasPlayingPR) {
          clearInterval(reloadInterval.value);
          startAutoReload();
        }
      }
    }
    onMounted(async () => {
      await loadConfig()
      await loadData()
      startAutoReload()
    })

    onUnmounted(() => {
      if (reloadInterval.value) {
        clearInterval(reloadInterval.value);
      }
    })

    return {
      mainVideo,
      defaultReview,
      selectedName,
      primePerformers,
      freeChatPerformers,
      loading,
      loadData,
      loadConfig,
      selectVideoMain,
      frames,
      prMov,
      isVideoLoading
    }
  }
}
</script>

<style scoped lang="scss">
main {

  img {
    max-width: 100%;
    display: block;
  }

  .pr {
    position: relative;
    padding: 0 3px 0 0;
    width: 69%;

    @media (max-width: 1166px) {
      width: 100%;
    }

    a {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 100%;
      height: 90%;
      cursor: pointer;
      z-index: 100;
    }
  }

  .flex {
    display: flex;
    justify-content: space-between;

    @media (max-width: 1166px) {
      flex-wrap: wrap;
    }
  }

  .prof-bt {
    text-decoration: none;
    background-color: #e525a5;
    color: #fff;
    display: inline-block;
    padding: 1rem 1.5rem;
    font-size: 11px;
    font-weight: 400;
    border-radius: 30px;
    line-height: 1;
  }

  .online {

    .preview {
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;
      gap: 5px;
      padding: 10px 0;

      iframe {
        width: 60%;
        height: auto;
        position: relative;
        border: 1px solid #d8c5ff;
        box-sizing: border-box;
      }

      &__block {
        background-color: #292f33;
        padding: 1em;
        box-sizing: border-box;
        height: auto;

        @media (min-width: 1167px) {
          padding-top: 1em;
          width: 30%;
          height: calc(100vh - 170px);
          display: flex;
          flex-direction: column;
          align-content: flex-start;
          justify-content: space-between;
          gap: 1em;
          overflow: auto;
        }
      }

      .iframe-container {
        position: relative;
        margin-bottom: .5rem;

        @media (min-width: 1167px) {
          width: 70%;
          margin-bottom: 0;
        }

        iframe {
          width: 100%;
          height: 100%;

          @media (max-width: 1166px) {
            height: 300px;
          }
        }
      }

      .play-link {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
        text-decoration: none;
      }

      &--info {
        padding: 0 2em 1.5em;
        border-bottom: 5px solid #000;
        column-gap: 2em;
        align-items: center;
        justify-content: space-between;
        line-height: 1;

        .name {
          font-size: 1.2em;
        }

        @media (max-width: 530px) {
          padding: 0 0 1em;
          margin-bottom: 1em;
        }
      }

      .review {
        height: 19em;
        overflow: auto;

        @media (max-width: 1166px) {
          margin-top: 1.5em;
          height: auto;
        }

        dt {
          background-color: #8950ff;
          padding: .2rem 1rem;
          margin: 0 auto 1em;
          text-align: center;
        }

        @media (max-width: 530px) {
          p {
            font-size: .9em;
            margin-bottom: 1rem;
          }
        }
      }
    }

    &__block {
      background-color: #111;
      color: #fff;

      @media (min-width: 1167px) {
        height: 90%;
        overflow: auto;
      }

      h2 {
        text-align: center;
        font-size: 2rem;
        font-weight: 700;
        padding: .5rem 2em .5rem 1em;
        background-color: #222;
        color: #fff000;

        img {
          height: 4rem;
          margin-right: 1rem;
        }
      }

      @media (max-width: 1166px) {
        h2 {
          font-size: 2rem;
          padding: .5rem 1em .5rem .5em;

          img {
            height: 3.5rem;
          }
        }
      }
    }

    .notice {
      padding: 3em 1em;
      justify-content: center;
      align-items: center;
      gap: 1em 2em;

      p {
        font-size: 1.2rem;
        font-weight: 500;
      }
    }
  }

  .video-area {
    h2 {
      background-color: #e525a5;
      margin-bottom: 0;
      text-align: center;
    }

    @media (max-width: 1166px) {
      margin-bottom: 1em;

      h2 {
        font-size: 1.1em;
        padding: .5rem 1em;
        margin-bottom: 0;
      }
    }
  }

  .thumbnails {
    gap: .5rem 1.25%;
    padding: 1em;
    flex-wrap: wrap;
    justify-content: flex-start;

    @media (max-width: 1166px) {
      gap: 1rem 1.5%;
      padding: 1em;
    }

    .thumbnail {
      font-size: .9em;
      background-color: #292f33;
      border: 1px solid #363a40;
      box-sizing: border-box;
      text-align: center;
      width: 24%;

      &:hover,
      &.active {
        background-color: #f26522;
      }

      @media (min-width: 1167px) and (max-width: 1200px) {
        width: 49.2%
      }

      @media (max-width: 1166px) {
        width: 49.2%
      }
    }

    .info--top {
      cursor: pointer;
      padding: .5rem;

      &:hover {
        background-color: #f26522;
      }

      .thumail--img {
        width: 100%;

        img {
          width: 100%;
          height: 80px;
          object-fit: cover;
          margin: 0 auto;
        }
      }
    }

    .name {
      display: flex;
      padding: .5rem 1rem;
      font-size: 1rem;
      font-weight: 500;
      justify-content: center;
      align-items: center;
      line-height: 1;

      @media (max-width: 530px) {
        flex-wrap: wrap;
        justify-content: center;
      }
    }

    .info--bottom {
      p {
        margin-bottom: .5rem;
        font-weight: 300;
        font-size: .9em;

        @media (max-width: 530px) {
          font-weight: 400;
          font-size: .85em;
        }
      }
    }

    .list {
      justify-content: space-between;
      align-items: center;
      background-color: #363a40;
      padding: .5rem 1.5rem;

      .viewers {
        i {
          padding-right: .5rem;
        }
      }

      .status {
        line-height: 1;
        display: block;
        border-radius: 2rem;
        padding: .3rem;
        box-sizing: border-box;
        font-size: 1.1rem;

        &.free {
          background-color: #f26522;
          width: 7.5em;
        }

        &.waite {
          background-color: #8950ff;
          letter-spacing: .1rem;
          margin: 0 auto;
          padding: .3rem .5em;
        }

        &.chatting {
          background-color: #e906f7;
          letter-spacing: .1rem;
          width: 7.5em;
        }
      }
    }
  }
}

.preview-container {
  width: calc(100% - 100px);

  @media (max-width: 1166px) {
    flex-direction: column;
    width: calc(100% - 80px);
    align-content: flex-start;
    padding-right: .5em;
  }
}

.sidebar {
  width: 100px;
  height: calc(100vh - 170px);
  overflow: auto;

  @media (max-width: 1166px) {
    width: 70px;
    height: 100vh;
  }

  .thumbnail-item {
    margin: 0 2px 2px;
    border: 2px solid #000;
    border-top: none;
    cursor: pointer;

    &.active,
    &:hover {
      border: 2px solid #e525a5;
    }
  }

  img {
    width: 100%;
  }
}

.video-container {
  @media (max-width: 1166px) {
    width: 100%;
  }

  video {
    width: 100%;
    max-width: 100%;
    height: 100%;
    object-fit: cover;
  }

}

#app .join-bt {
  max-width: 320px;
  margin: 0 auto;
  border-radius: 0;
  border: 1px solid #fff;

  &:hover {
    letter-spacing: 0;
  }

  span {
    display: inline-block;
    font-size: 2rem;

    &.yellow {
      color: #fff000;
    }

    &.underline {
      text-decoration: underline;
      padding-left: .2rem;
    }
  }

  @media (max-width: 600px) {
    font-size: 1.2rem;
    margin-bottom: 2em;

    .spacing--less {
      font-size: 1.1em
    }
  }
}

.video-container-inner {
  position: relative;
}

.video-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 1em 2em;
  border-radius: 5px;
  font-size: 1.2em;
  z-index: 90;
}
</style>